export default "__VITE_ASSET__4900c96b__"